import React from "react";
import "./Accordion.css";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AccordionContainer = (props) => {
  const { title, children } = props;
  return (
    <>
      <Accordion disableGutters={true} square={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          <Typography className='title'>{title}</Typography>
        </AccordionSummary>
        <Divider />
        <AccordionDetails sx={{ padding: "1rem" }}>{children}</AccordionDetails>
      </Accordion>
    </>
  );
};

export default AccordionContainer;
